import axios from 'axios';
import config from '../config';

const API_URL = config.API_BASE_URL;

// Get wallets for a specific branch
export const getBranchWallets = async (branchId) => {
  try {
    const response = await axios.get(`${API_URL}/Wallets/branch/${branchId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching branch wallets:', error);
    throw error;
  }
};

// Submit transaction (payment proof)
export const submitTransaction = async (transactionData) => {
  try {
    const response = await axios.post(`${API_URL}/Transactions`, transactionData);
    return response.data;
  } catch (error) {
    console.error('Error submitting transaction:', error);
    throw error;
  }
};

// Get transaction by order ID
export const getTransactionByOrderId = async (orderId) => {
  try {
    const response = await axios.get(`${API_URL}/Transactions/order/${orderId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching transaction:', error);
    throw error;
  }
};
